import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { ErrorCodeDefinitions } from './_constants';

const ErrorCodeTable = () => {
	return (
		<TableContainer component={Paper}>
			<Table size='medium' aria-label='Server Error Codes'>
				<TableHead>
					<TableRow>
						<TableCell>
							<strong>Code</strong>
						</TableCell>
						<TableCell>
							<strong>IP</strong>
						</TableCell>
						<TableCell>
							<strong>Name</strong>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{ErrorCodeDefinitions.map(row => (
						<TableRow key={row.IP}>
							<TableCell component='th' scope='row'>
								{row.Code}
							</TableCell>
							<TableCell>{row.IP}</TableCell>
							<TableCell>{row.Domain}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default ErrorCodeTable;
